import React from "react";
import {CButton, CRow} from "@coreui/react";
import {Link} from "react-router-dom";
import "./AddButtonRow.scss";
import {withErrorBoundary} from "../ErrorBoundary";
import {useTranslation} from "react-i18next";
import ProjectSelector from "../ProjectSelector";
import classNames from "classnames";

const AddButtonRow = (props) => {
  const {className, path, onClick, disabled, selectOptions, onSelectChange, hasAddPermission = true} = props;
  const {t} = useTranslation();
  const showProjectSelector = !!selectOptions && !!onSelectChange;

  return (
    (showProjectSelector || !!hasAddPermission) &&
    <CRow className={classNames("AddButtonRow", {"AddButtonRow_space-between": !!selectOptions}, className)}>
      {
        showProjectSelector &&
        <ProjectSelector
          options={selectOptions}
          onChange={onSelectChange}
          disabled={disabled}
        />
      }
      {
        hasAddPermission &&
        <CButton
          tag={path && Link}
          to={path}
          color="dark"
          variant="outline"
          className="AddButtonRow__add-button"
          onClick={onClick}
          disabled={disabled}
        >
          {t("button.add", "Add")}
        </CButton>
      }
    </CRow>
  );
};

AddButtonRow.defaultProps = {
  className: "add-button-row"
};

export default withErrorBoundary(AddButtonRow);